<template>
	<section id="temas">
		<container textButton="PUBLICAR"  pathName="create">
		<load-content v-if="loadContent" />
			<div class="table-wrapper" v-if="temas.length > 0 && !loadContent">
					<div class="table">
						<table>
							<thead>
								<tr>
									<th>Nome</th>
									<th>Status</th>
									<th>Última Atualização</th>
								</tr>
							</thead>
							<tbody>
								<tr class="fields" v-for="tema in temas" :key="tema.id">
									<td><span>{{ tema.titulo }}</span></td>
									<td><span>{{ tema.status }}</span></td>
									<!--<td><span>{{ new Date(tema.dataAtualizacao).getDate() + '/' +((new Date(tema.dataAtualizacao).getMonth()) + 1) }}</span></td>-->
									<td><span>{{formatDateAndTime(tema.dataAtualizacao) }}</span></td>
								</tr>
							</tbody>
						</table>
					</div>
			</div>
			<div v-else-if="inicial" class="objectNotFound">
						Nenhum tema publicado :)
				</div>
		</container>
	</section>
</template>
<script>
import { tipos } from '@/services/tipos'
import { formatDateAndTime } from '@/helpers/DateTime'
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import { objetos } from '@/services/objetos'
import { integracao } from '@/services/integracoes'
export default {
	name: 'TemasList',
	components: {
		container, LoadContent
	},
	data () {
		return {
			loadingSubmit: false,
			loadContent: false,
			temas: [],
			inicial: false,
			status: [],
			selecionados: [],
			temasBackup: [],
			form: {
				temas: []
			}
		}
	},
	async created () {
		this.loadContent = true
		const tipo = {
			nome: 'Tema'
		}
		const retornoTipo = await tipos.find(tipo)
		const temasRetorno = await objetos.find({ tipos: retornoTipo.data[0].id, quantidade: 20000 })

		const status = await integracao.obterStatus({})

		this.status = status.data
		const temas = []

		temasRetorno.data.map((tema, index) => {
			const statusTeste = status.data.filter(st => st.codigoObjeto.toString().toLowerCase() === tema.id.toString().toLowerCase())
			if (statusTeste.length) {
				temas.push(Object.assign(tema, statusTeste[0]))
			}
		})
		this.temas = this.temasBackup = temas
		this.inicial = true
		this.loadContent = false
	},
	methods: {
		buscar (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const retorno = this.temasBackup.filter(function (el) {
				return condition.test(el.titulo.toLowerCase())
			})
			this.temas = retorno
		},
		formataObjeto (e) {
			const tema = this.form.temas.findIndex(tema => tema.id === e.target.value)
			const selecionado = this.selecionados.findIndex(s => s === e.target.value)

			if (tema !== -1) {
				this.form.temas = this.form.temas.filter(tema => tema.id !== e.target.value)
			} else {
				const temaObject = this.temas.filter(tema => tema.id === e.target.value)
				this.form.temas.push({
					id: temaObject[0].id,
					urlObjeto: temaObject[0].urlObjeto
				})
			}
			if (selecionado !== -1) {
				this.selecionado = this.selecionados.splice(selecionado, 1)
			} else {
				this.selecionados.push(e.target.value)
			}
		},
		formatDateAndTime (date) {
			return formatDateAndTime(date)
		}
	}
}
</script>
<style lang="scss" scoped>
#temas {
	.search-section {
		border: 1px solid #f2f2f2;
		input {
			padding: 0px 10px 0px 0px;
		}
	}
	.publicacoes {
		max-height: 400px;
		color: #000;
		overflow: auto;
	}
}
.objectNotFound {
	color: #000;
	text-align: center;
}

::-webkit-scrollbar {
    width: 12px;
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  outline: 1px solid slategrey;
}
</style>
